// extracted by mini-css-extract-plugin
export default {"Publicity":"Publicity_Publicity__zRzmP"};